// Libs
import Vue from 'vue'
import Router from 'vue-router'
// Main Components
// App Specific
import Home from '@/components/LangGG/Home'
import TagPage from '@/components/LangGG/TagPage'
import GamePage from '@/components/LangGG/GamePage'
import Profile from '@/components/LangGG/Profile'
import Login from '@/components/LangGG/Login'
import PaymentError from '@/components/LangGG/PaymentError'
// Lang Specific
import LP from '@/components/LangGG/BG/LP'
import LPOtp from '@/components/LangGG/BG/LPOtp'
import LPDcb from '@/components/LangGG/BG/LPDcb'
import Deactivation from '@/components/LangGG/BG/Deactivation'
import Contact from '@/components/LangGG/BG/Contact'
import Imprint from '@/components/LangGG/BG/Imprint'
import Terms from '@/components/LangGG/BG/Terms'
import Wait from '@/components/LangGG/BG/Wait'


Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            name: 'Home',
            component: Home
        },
        {
            path: '/profile',
            name: 'Profile',
            component: Profile
        },
        {
            path: '/tag/:name',
            name: 'TagPage',
            component: TagPage
        },
        {
            path: '/game/:id',
            name: 'GamePage',
            component: GamePage
        },
        {
            path: '/deactivation',
            name: 'Deactivation',
            component: Deactivation
        },
        {
            path: '/contact',
            name: 'Contact',
            component: Contact
        },
        {
            path: '/imprint',
            name: 'Imprint',
            component: Imprint
        },
        {
            path: '/terms-and-conditions',
            name: 'Terms',
            component: Terms
        },
        {
            path: '/payment-error',
            name: 'PaymentError',
            component: PaymentError
        },
        {
            path: '/wait',
            name: 'Wait',
            component: Wait
        },
        {
            path: '/login',
            name: 'Login',
            component: Login
        },
        {
            path: '/lp',
            name: 'LP',
            component: LP
        },
        {
            path: '/lpotp',
            name: 'LPOtp',
            component: LPOtp
        },
        {
            path: '/lpdcb',
            name: 'LPDcb',
            component: LPDcb
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/gg/bg.js